<template>
    <v-dialog v-model="dialog" max-width="950px" persistent overlay-color="black">
        <v-card>
            <v-form v-model="valid"
                    ref="formSaveCancel">
                <v-col  cols="12" sm="12" md="12">
                    <v-card outlined>
                        <v-card-title class="text-h5 font-weight-bold">
                            Cancelar Encaminhamento
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                large
                                elevation="0"
                                class="grey darken-2"
                                @click="close">
                                <v-icon left>mdi-close</v-icon>
                            Fechar
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>

                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="9" md="9">
                                    <span class="blue--text">{{this.nomeCidadao}}</span><br><br>
                                    <span class="font-weight-bold">Nome Social: </span>{{this.nomeSocial}}<br>
                                    <span class="font-weight-bold">Código cidadão: </span>{{this.codigoSisaCidacao}}<br>
                                    <span class="font-weight-bold">Nome da Mãe: </span>{{this.nomeMae}} <br>
                                </v-col>
                                <v-col cols="6" sm="3" md="3"><span class="font-weight-bold">Data Nascimento: </span>{{this.dtNascimento}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" sm="3" md="3"><span class="font-weight-bold">Data de Cadastro do Encaminhamento:</span></v-col>
                                <v-col cols="6" sm="3" md="3"><span class="blue--text">{{ this.dataCadastroReserva }}</span></v-col>
                                <v-col cols="6" sm="3" md="3"><span class="font-weight-bold">Reordenamento:</span></v-col>
                                <v-col cols="6" sm="3" md="3">{{this.reordenamento}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" sm="2" md="2"><span class="font-weight-bold">Nome do Serviço:</span></v-col>
                                <v-col cols="12" sm="10" md="10"><span class="blue--text">{{this.nomeServico}}</span></v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3" sm="2" md="2"><span class="font-weight-bold">Tipo de Serviço:</span></v-col>
                                <v-col cols="12" sm="10" md="10">{{this.tipoServico}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4" sm="2" md="2"><span class="font-weight-bold">Ambiente:</span></v-col>
                                <v-col cols="6" sm="4" md="4">{{this.ambiente}}</v-col>
                                <v-col cols="6" sm="2" md="2"><span class="font-weight-bold">Tipo do Ambiente:</span></v-col>
                                <v-col cols="6" sm="4" md="4">{{this.tipoAmbiente}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" sm="2" md="2"><span class="font-weight-bold">Rótulo da Mobília:</span></v-col>
                                <v-col cols="6" sm="4" md="4">{{this.mobilia}}</v-col>
                                <v-col cols="6" sm="2" md="2"><span class="font-weight-bold">Tipo de Mobília:</span></v-col>
                                <v-col cols="6" sm="4" md="4">{{tipoMobilia}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" sm="3" md="3"><span class="font-weight-bold">Identificação da Vaga:</span></v-col>
                                <v-col cols="6" sm="3" md="3">{{this.identificacaoVaga}}</v-col>
                                <v-col cols="6" sm="3" md="3"><span class="font-weight-bold">Acessibilidade da Vaga:</span></v-col>
                                <v-col cols="6" sm="3" md="3">{{this.acessibilidadeVaga}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-divider></v-divider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-select
                                        clearable
                                        item-value="value"
                                        item-text="text"
                                        :items="listMotivosCancelamento"
                                        v-model="idMotivo"
                                        label="Motivo*"
                                        outlined
                                        :rules="[rules.required]"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                <v-textarea
                                    clearable
                                    v-model="justificativa"
                                    id="txDescription"
                                    label="Justificativa*"
                                    maxLength="70"
                                    :counter="70"
                                    rows="4"
                                    rows-height="4"
                                    outlined
                                    :rules="[rules.required]"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col  cols="12" sm="12" md="12">
                    <v-card elevation="0">
                        <v-card-text>
                            <v-row class="d-flex justify-end">
                                    <v-btn
                                        color="primary"
                                        large
                                        outlined
                                        rounded 
                                        @click="close"
                                        elevation="0">
                                            Cancelar</v-btn>
                                
                                    <v-btn 
                                        color="primary"
                                        large
                                        rounded
                                        elevation="0"
                                        @click="save"
                                    >
                                    Salvar</v-btn>
                            </v-row>
                        </v-card-text>
                    </v-card>

                </v-col>
            </v-form>
        </v-card>
        <snackbar
            :text="snackbarMessage"
            :color="snackbarColor"
        />
        <v-dialog
            v-model="dialogCancelInserted"
            width="500"
        >
            <v-card>
                <v-card-title class="light-blue darken-4 white--text">
                Atenção
                </v-card-title>

                <v-card-text>
                <br/>
                Cancelamento efetuado com sucesso!
                <br/>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    large
                    outlined
                    rounded
                    elevation="0"
                    @click="retornarDetalheSolicitacao"
                >
                    CONFIRMAR
                </v-btn>
                </v-card-actions>
            </v-card>    
        </v-dialog>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import snackbarMixin from "@/mixins/snackbar.mixin";
import citizenService from '../../services/citizen.service';

export default {
    mixins: [snackbarMixin],
    props:{
        dialog:{
            default:false
            }
    },
    data(){
        return {
            listCitizen:[],
            valid:true,
            dialogCancelInserted:false,
            idMotivo:'',
            justificativa:'',
            idSolicitacao:0,
            idEncaminhamento:null,
            idCidadaoSolicitacao:null,
            dataCadastroReserva:'',
            nomeCidadao:'',
            nomeSocial:'',
            nomeMae:'',
            codigoSisaCidacao:'',
            dtNascimento:'',
            nomeServico: '',
            tipoServico:'',
            reordenamento:'',
            ambiente:'',
            tipoAmbiente:'',
            mobilia:'',
            tipoMobilia:'',
            identificacaoVaga:'',
            acessibilidadeVaga:'',
            rules:{
                    required: value => value && !!value.trim() || 'Campo obrigatório'
            }
        }
    },
    mounted(){
        this.loadList();
    },
    computed: {
        ...mapGetters('lists',['listMotivosCancelamento']),
        ...mapGetters('citizen',['getReturnStatus', 'getErrosOnSave'])
    },
    methods:{
        async loadList(){
            await this.$store.dispatch("lists/listMotivosCancelamento");
        }, 
        close(){
            this.$emit('update:dialog', false)
        },
        save(){
            if(this.$refs.formSaveCancel.validate()){
                this.$store.state.loading = true;
                let data = {
                    codigoEncaminhamento: this.idEncaminhamento,
                    codigoCidadao: this.idCidadaoSolicitacao,
                    codigoMotivoCancelamento: this.idMotivo,
                    justificativa: this.justificativa
                };
                 
                this.$store.dispatch('citizen/save', data)
                .then(()=> {
                    this.$store.state.loading = false;
                    console.log('---------------------------------------------------------');
                    console.log(this.getReturnStatus.toLowerCase());
                    if(this.getReturnStatus.toLowerCase() == 'ok'){
                        this.dialogCancelInserted = true;
                    } else {
                        this.dialogError = true;
                        this.returnedErrorMessage = '<ul><li>' + this.getErrosOnSave.join('<li /><li>') + '</li></ul>';
                        console.log(this.getErrosOnSave);
                        console.log(this.returnedErrorMessage);
                    }
                    console.log('---------------------------------------------------------');
                })
                .catch(error=>{
                    console.log(error);
                    this.$store.state.loading = false;
                    this.showSnackbar('Não foi possível processar a requisição. Dados inválidos', 'error');
                });

            }
        },
        clear(){
            this.justificativa='';
            this.idMotivo='';
        },
        retornarDetalheSolicitacao(){
            var indexOfCitizen = this.listCitizen.findIndex(obj => { return obj.codigoCidadaoSolicitacao == this.idCidadaoSolicitacao });
            this.$set(this.listCitizen[indexOfCitizen], 'descricaoStatusEncaminhamento', 'Cancelado');
            this.close();
        },
        loadForwardingCitizen(idFormulario, idEncaminhamento, idCidadao, list){
            if(idFormulario && idEncaminhamento){
                this.idEncaminhamento = idEncaminhamento;
                this.idCidadaoSolicitacao = idCidadao;
                this.idSolicitacao = parseInt(idFormulario);
                this.listCitizen = list;
                citizenService.getEncaminhamentoCidadao(idEncaminhamento, parseInt(idFormulario))
                .then(result => {
                    if(result.status == 200 && result.data){
                        let r = result.data;
                        if(r) {
                            this.nomeServico = r.nm_servico;
                            this.tipoServico = r.dc_tipo_servico;
                            this.dataCadastroReserva = r.dataCadastroReserva;
                            this.reordenamento = r.descricaoReordenamento;
                            this.ambiente = r.descricaoAmbiente;
                            this.tipoAmbiente=r.tipoAmbiente;
                            this.mobilia=r.tx_rotulo_mobilia;
                            this.tipoMobilia=r.descricaoTipoMobilia;
                            this.identificacaoVaga=r.nrIdentificacaoVagaFormatada;
                            this.acessibilidadeVaga=r.descricaoAcessibilidade;
                            this.nomeCidadao= r.nm_cidadao;
                            this.nomeSocial = r.nm_apelido;
                            this.nomeMae = r.nm_mae;
                            this.dtNascimento = r.dtNascimento;
                            this.codigoSisaCidacao =r.ci_cidadao;
                        }
                    }
                }).catch(error => {
                    this.showSnackbar("Não foi possível efetuar a operação.", 'error');
                    console.log(error);
                });
            }
        }
    }
}
</script>